module.exports = {"data":{"contentfulSiteSettings":{"title":"TônNguyễn","description":"Full-stack developer, biker, skateboarder and a father"}},"layoutContext":{}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/layout-404-index.json
// module id = 191
// module chunks = 60335399758886 243011796346917